module.exports = __webpack_public_path__ + "img/icon-base-colour.c60c91c7.png";